import "../../06-protoypes/parents";
import "../../06-protoypes/index";
import Pagination from "./pagination";

export default function initializeFilterTabs(faqElement) {
  if (!faqElement) return;

  const filterTabsElements = faqElement.querySelectorAll(".filter-tabs__item");

  if (filterTabsElements.length === 0) {
    return;
  }

  const pagination = initializePagination(5, faqElement);

  const searchInput = faqElement.querySelector("#faq__search--input");
  if (searchInput) {
    for (const eventName of ["keyup"]) {
      searchInput.addEventListener(eventName, (e) => {
        const { value } = searchInput;

        if (value !== "") {
          for (const tab of filterTabsElements) {
            tab.classList.remove("filter-tabs__item--active");
          }
        }

        /** @param {HTMLDivElement} currentTarget */
        const { currentTarget } = e;
        filterQuestionsBySearch(
          currentTarget.value,
          faqElement.querySelectorAll(".faq__results .accordion__item"),
          faqElement
        );

        if (value.length > 0) {
          pagination.build(undefined, value);

          initPaginationPagesClickHandler(pagination, faqElement);

          const { itemsToShow, itemsToHide } = pagination.paginate(
            1,
            undefined,
            currentTarget.value
          );
          for (const item of itemsToShow) {
            item.removeAttribute("hidden");
            item.style.display = "block";
          }

          for (const item of itemsToHide) {
            item.setAttribute("hidden", "hidden");
            item.style.display = "none";
          }
        } else {
          const faqCategory = faqElement.querySelector(
            ".filter-tabs__item--active"
          ).dataset.faqCategory;
          pagination.build(faqCategory);

          initPaginationPagesClickHandler(pagination, faqElement);

          const { itemsToShow, itemsToHide } = pagination.paginate(
            1,
            faqCategory
          );
          for (const item of itemsToShow) {
            item.removeAttribute("hidden");
            item.style.display = "block";
          }
          for (const item of itemsToHide) {
            item.setAttribute("hidden", "hidden");
            item.style.display = "none";
          }
        }
      });
    }
  }

  const selectCategory = faqElement.querySelector(
    ".filter-tabs__mobile .select__field"
  );

  if (searchInput && searchInput.value.length < 1) {
    selectCategory.addEventListener("change", function (e) {
      const faqCategory = e.target.value;

      if (searchInput) {
        searchInput.value = "";
      }

      mobileFilter(
        faqCategory,
        faqElement.querySelectorAll(
          ".faq__results .accordion__item .accordion__label"
        ),
        faqElement
      );

      pagination.build(faqCategory);

      const { itemsToShow, itemsToHide } = pagination.paginate(1, faqCategory);

      for (const item of itemsToShow) {
        item.removeAttribute("hidden");
        item.style.display = "block";
      }

      for (const item of itemsToHide) {
        item.setAttribute("hidden", "hidden");
        item.style.display = "none";
      }

      initPaginationPagesClickHandler(pagination, faqElement);
    });
  }

  for (const tab of filterTabsElements) {
    tab.onclick = (e) => {
      /** @param {HTMLDivElement} currentTarget */
      const { currentTarget } = e;

      if (currentTarget.classList.contains("filter-tabs__item--active")) {
        return false;
      }

      const { faqCategory } = currentTarget.dataset;

      for (const tab of filterTabsElements) {
        if (
          tab.isSameNode(currentTarget) &&
          !tab.classList.contains("filter-tabs__item--active")
        ) {
          tab.classList.add("filter-tabs__item--active");
          if (searchInput) {
            searchInput.value = "";
          }
          continue;
        }
        tab.classList.remove("filter-tabs__item--active");
      }

      filterQuestionsByCategory(
        faqCategory,
        faqElement.querySelectorAll(
          ".faq__results .accordion__item .accordion__label"
        ),
        currentTarget.querySelector("span").textContent,
        faqElement
      );

      pagination.build(faqCategory);
      initPaginationPagesClickHandler(pagination, faqElement);
      const { itemsToShow, itemsToHide } = pagination.paginate(1, faqCategory);

      for (const item of itemsToShow) {
        item.removeAttribute("hidden");
        item.style.display = "block";
      }
      for (const item of itemsToHide) {
        item.setAttribute("hidden", "hidden");
        item.style.display = "none";
      }
    };
  }
}

const initializePagination = (minPagesForDots, faqElement) => {
  const { paginationItemsperpage: itemsPerPage } = faqElement.querySelector(
    ".tx-goldgas-faq .faq"
  ).dataset;

  const pagination = new Pagination(
    faqElement,
    faqElement.querySelectorAll(`.faq .accordion`),
    parseInt(itemsPerPage),
    minPagesForDots,
    ".pagination__arrow.pagination__arrow--prev",
    ".pagination__arrow.pagination__arrow--next",
    faqElement.querySelector(
      ".filter-tabs__item.filter-tabs__item--active"
    ).dataset.faqCategory,
  );

  pagination.paginate(
    1,
    faqElement.querySelector(".filter-tabs__item.filter-tabs__item--active")
      .dataset.faqCategory
  );

  initPaginationPagesClickHandler(pagination, faqElement);

  return pagination;
};

const initPaginationPagesClickHandler = (pagination, faqElement) => {
  const actions = faqElement.querySelectorAll(
    ".faq__pagination .pagination__action"
  );

  for (const action of actions) {
    action.onclick = (e) => {
      const { currentTarget } = e;
      const targetedPage = parseInt(currentTarget.textContent);
      const searchTerm = faqElement.querySelector("#faq__search--input").value;

      if (currentTarget.parentNode.classList.contains("pagination__arrow")) {
        return false;
      }

      for (const action of actions) {
        if (
          action.isSameNode(currentTarget) &&
          !action.parentNode.classList.contains("pagination__item--active")
        ) {
          action.parentNode.classList.add("pagination__item--active");
          continue;
        }
        action.parentNode.classList.remove("pagination__item--active");
      }

      const currentIndex = currentTarget.parentNode.index();
      const nodes =
        currentTarget.parentNode.parentNode.querySelectorAll(
          ".pagination__item"
        );

      for (const node of nodes) {
        if (node.length < 3) {
          node.setAttribute("hidden", "hidden");
        }
      }

      let prevNodes = [...nodes].slice(currentIndex - 2, currentIndex + 1);
      let nextNodes = [...nodes].slice(currentIndex + 1, currentIndex + 3);

      if (nextNodes.length < 2) {
        prevNodes = [...nodes].slice(
          currentIndex - 2 - (2 - nextNodes.length),
          currentIndex + 1
        );
      }
      if (prevNodes.length < 2) {
        nextNodes = [...nodes].slice(0, 5);
      }

      for (const node of [...prevNodes, ...nextNodes]) {
        node.removeAttribute("hidden");
      }

      if (currentIndex > 2 && [...nodes].length >= currentIndex + 3) {
        [...nodes][currentIndex - 3].setAttribute("hidden", "hidden");
      }

      if (currentIndex >= 2 && [...nodes][currentIndex + 3]) {
        [...nodes][currentIndex + 3].setAttribute("hidden", "hidden");
      }

      for (const node of nodes) {
        for (let i = node.index(); i < currentIndex - 3; i++) {
          if (currentIndex < nodes.length - 1) {
            [...nodes][i].setAttribute("hidden", "hidden");
          }
        }

        for (
          let i = node.index();
          i > currentIndex + 3 && i < nodes.length;
          i++
        ) {
          if (currentIndex > 0) {
            [...nodes][i].setAttribute("hidden", "hidden");
          }
        }
      }

      const prevArrow = faqElement.querySelector(
        ".pagination__arrow.pagination__arrow--prev"
      );
      const nextArrow = faqElement.querySelector(
        ".pagination__arrow.pagination__arrow--next"
      );
      if (currentIndex + 1 == [...nodes].length) {
        nextArrow.style.visibility = "hidden";
      } else {
        nextArrow.style.visibility = "visible";
      }
      if (currentIndex == 0) {
        prevArrow.style.visibility = "hidden";
      } else {
        prevArrow.style.visibility = "visible";
      }

      if (window.innerWidth < 1200) {
        const { itemsToShow, itemsToHide } = pagination.paginate(
          targetedPage,
          faqElement.querySelector(".filter-tabs__mobile .select__field").value,
          searchTerm
        );

        for (const item of itemsToHide) {
          item.setAttribute("hidden", "hidden");
          item.style.display = "none";
        }

        for (const item of itemsToShow) {
          item.removeAttribute("hidden");
          item.style.display = "block";
        }
      } else {
        const { itemsToShow, itemsToHide } = pagination.paginate(
          targetedPage,
          faqElement.querySelector(
            ".filter-tabs__item.filter-tabs__item--active"
          )?.dataset.faqCategory,
          searchTerm
        );

        for (const item of itemsToHide) {
          item.setAttribute("hidden", "hidden");
          item.style.display = "none";
        }

        for (const item of itemsToShow) {
          item.removeAttribute("hidden");
          item.style.display = "block";
        }
      }
    };
  }
};

/**
 * @param {String} searchTerm
 * @param {NodeListOf<HTMLElement>} questions
 */
const filterQuestionsBySearch = (searchTerm, questions, faqElement) => {
  /** @param {NodeListOf<HTMLElement|[]>} */
  const result = [];

  for (const question of questions) {
    const item = question.parents(".accordion");
    const questionText = item.textContent.toLowerCase();
    const firstFaqItem = faqElement.querySelector(
      ".filter-tabs__item:nth-child(1)"
    );
    const firstTabCategory = firstFaqItem.getAttribute("data-faq-category");

    if (
      searchTerm.length > 0 &&
      questionText.includes(searchTerm.toLowerCase())
    ) {
      item.style.display = "block";
      item.removeAttribute("hidden");
      result.push(item);
    } else if (
      searchTerm.length === 0 &&
      item.getAttribute("data-faq-category") === firstTabCategory
    ) {
      item.style.display = "block";
      item.removeAttribute("hidden");
      result.push(item);
    } else {
      item.style.display = "none";
      item.setAttribute("hidden", "hidden");
    }
  }

  const jsCounter = faqElement.querySelector("#faq__counter--js");
  const jsLabel = faqElement.querySelector("#faq__counter--jslabel");
  const jsCounterCat = faqElement.querySelector("#faq__counter--category");

  if (jsCounter) {
    const counterWord = jsCounter
      .parents("p")
      .querySelector("span.faq__counter--word");

    if (searchTerm.length > 0) {
      jsLabel.textContent = "für den Suchbegriff";
      jsCounterCat?.setAttribute("hidden", "hidden");
      counterWord.textContent = searchTerm;
    } else {
      jsLabel.textContent = "für die Kategorie";
      jsCounterCat?.removeAttribute("hidden");
      const firstFaqItem = faqElement.querySelector(
        ".filter-tabs__item:nth-child(1)"
      );
      firstFaqItem.dispatchEvent(
        new Event("click", {
          cancelable: false,
          bubbles: true,
        })
      );

      counterWord.textContent = firstFaqItem.querySelector("span").textContent;
    }

    const { length } = result;
    jsCounter.textContent = `${length} ${
      length === 1 ? "Ergebnis" : "Ergebnisse"
    }`;
  }
};

/**
 * @param {String} category
 * @param {NodeListOf<HTMLElement>} questions
 * @param {String} categoryLabel
 */
const filterQuestionsByCategory = (category, questions, categoryLabel, faqElement) => {
  /** @param {NodeListOf<HTMLElement|[]>} */
  const result = [];

  for (const question of questions) {
    const item = question.parents(`.accordion`);
    const { faqCategory } = item.dataset;

    if (String(faqCategory) == String(category)) {
      item.style.display = "block";
      item.removeAttribute("hidden");
      result.push(item);
    } else {
      item.style.display = "none";
      item.setAttribute("hidden", "hidden");
    }
  }

  const jsCounter = faqElement.querySelector("#faq__counter--js");
  if (jsCounter) {
    const counterWord = jsCounter
      .parents("p")
      .querySelector("span.faq__counter--word");
    const { length } = result;
    jsCounter.textContent = `${length} ${
      length === 1 ? "Ergebnis" : "Ergebnisse"
    }`;
    counterWord.textContent = categoryLabel;
  }
};

/**
 * @param {NodeListOf<HTMLElement>} questions
 */
function mobileFilter(category, questions, faqElement) {
  const mobileFilter = faqElement.querySelector(
    ".filter-tabs__mobile .select__field"
  );
  const mobileWidth = window.innerWidth < 1200;

  if (mobileFilter.length === 0) {
    return;
  }

  if (mobileWidth) {
    const result = [];
    for (const question of questions) {
      const item = question.parents(`.accordion`);
      const { faqCategory } = item.dataset;

      if (String(faqCategory) == String(category)) {
        item.style.display = "block";
        item.removeAttribute("hidden");
        result.push(item);
      } else {
        item.style.display = "none";
        item.setAttribute("hidden", "hidden");
      }
    }

    const jsCounter = faqElement.querySelector("#faq__counter--js");
    const jsLabel = faqElement.querySelector("#faq__counter--jslabel");
    const jsCounterCat = faqElement.querySelector("#faq__counter--category");
    const selectField = faqElement.querySelector(
      ".filter-tabs__mobile .select__field"
    );

    if (jsCounter) {
      const counterWord = jsCounter
        .parents("p")
        .querySelector("span.faq__counter--word");
      const searchTerm = faqElement.querySelector("#faq__search--input").value;

      if (searchTerm.length > 0) {
        jsLabel.textContent = "für den Suchbegriff";
        jsCounterCat?.setAttribute("hidden", "hidden");
        counterWord.textContent = searchTerm;
      } else {
        jsLabel.textContent = "für die Kategorie";
        jsCounterCat?.removeAttribute("hidden");
        counterWord.textContent =
          selectField.options[selectField.selectedIndex].text;
      }

      const { length } = result;
      jsCounter.textContent = `${length} ${
        length === 1 ? "Ergebnis" : "Ergebnisse"
      }`;
    }
  }
}
